export const CardFeaturesIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M38 22.5V34.5C38 35.05 37.8042 35.5208 37.4125 35.9125C37.0208 36.3042 36.55 36.5 36 36.5H20C19.45 36.5 18.9792 36.3042 18.5875 35.9125C18.1958 35.5208 18 35.05 18 34.5V22.5C18 21.95 18.1958 21.4792 18.5875 21.0875C18.9792 20.6958 19.45 20.5 20 20.5H36C36.55 20.5 37.0208 20.6958 37.4125 21.0875C37.8042 21.4792 38 21.95 38 22.5ZM20 24.5H36V22.5H20V24.5ZM20 28.5V34.5H36V28.5H20Z"
        fill={fill}
      />
    </svg>
  );
};

export const RespCardFeaturesIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <path
        d="M22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6ZM4 8H20V6H4V8ZM4 12V18H20V12H4Z"
        fill={fill}
      />
    </svg>
  );
};

export const UnlinkRogersAcc = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <g transform="translate(17, 17)">
        <path
          d="M19.2499 16.9508L17.7499 15.4008C18.4166 15.2174 18.9582 14.8633 19.3749 14.3383C19.7916 13.8133 19.9999 13.2008 19.9999 12.5008C19.9999 11.6674 19.7082 10.9591 19.1249 10.3758C18.5416 9.79245 17.8332 9.50078 16.9999 9.50078H12.9999V7.50078H16.9999C18.3832 7.50078 19.5624 7.98828 20.5374 8.96328C21.5124 9.93828 21.9999 11.1174 21.9999 12.5008C21.9999 13.4508 21.7541 14.3258 21.2624 15.1258C20.7707 15.9258 20.0999 16.5341 19.2499 16.9508ZM15.8499 13.5008L13.8499 11.5008H15.9999V13.5008H15.8499ZM19.7999 23.1008L1.3999 4.70078L2.7999 3.30078L21.1999 21.7008L19.7999 23.1008ZM10.9999 17.5008H6.9999C5.61657 17.5008 4.4374 17.0133 3.4624 16.0383C2.4874 15.0633 1.9999 13.8841 1.9999 12.5008C1.9999 11.3508 2.3499 10.3258 3.0499 9.42578C3.7499 8.52578 4.6499 7.93411 5.7499 7.65078L7.5999 9.50078H6.9999C6.16657 9.50078 5.45824 9.79245 4.8749 10.3758C4.29157 10.9591 3.9999 11.6674 3.9999 12.5008C3.9999 13.3341 4.29157 14.0424 4.8749 14.6258C5.45824 15.2091 6.16657 15.5008 6.9999 15.5008H10.9999V17.5008ZM7.9999 13.5008V11.5008H9.6249L11.5999 13.5008H7.9999Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const RespUnlinkRogersAcc = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <path
        d="M19.2499 16.9508L17.7499 15.4008C18.4166 15.2174 18.9582 14.8633 19.3749 14.3383C19.7916 13.8133 19.9999 13.2008 19.9999 12.5008C19.9999 11.6674 19.7082 10.9591 19.1249 10.3758C18.5416 9.79245 17.8332 9.50078 16.9999 9.50078H12.9999V7.50078H16.9999C18.3832 7.50078 19.5624 7.98828 20.5374 8.96328C21.5124 9.93828 21.9999 11.1174 21.9999 12.5008C21.9999 13.4508 21.7541 14.3258 21.2624 15.1258C20.7707 15.9258 20.0999 16.5341 19.2499 16.9508ZM15.8499 13.5008L13.8499 11.5008H15.9999V13.5008H15.8499ZM19.7999 23.1008L1.3999 4.70078L2.7999 3.30078L21.1999 21.7008L19.7999 23.1008ZM10.9999 17.5008H6.9999C5.61657 17.5008 4.4374 17.0133 3.4624 16.0383C2.4874 15.0633 1.9999 13.8841 1.9999 12.5008C1.9999 11.3508 2.3499 10.3258 3.0499 9.42578C3.7499 8.52578 4.6499 7.93411 5.7499 7.65078L7.5999 9.50078H6.9999C6.16657 9.50078 5.45824 9.79245 4.8749 10.3758C4.29157 10.9591 3.9999 11.6674 3.9999 12.5008C3.9999 13.3341 4.29157 14.0424 4.8749 14.6258C5.45824 15.2091 6.16657 15.5008 6.9999 15.5008H10.9999V17.5008ZM7.9999 13.5008V11.5008H9.6249L11.5999 13.5008H7.9999Z"
        fill={fill}
      />
    </svg>
  );
};
